    export const PRODUCT_LOAN_SIX_INSTALLMENTS = 'loan-six-installments'
    export const PRODUCT_LOAN_SIX_INSTALLMENTS_PAYDAY = 'loan-six-installments-payday'
    
    export const CONFIG = {
        [PRODUCT_LOAN_SIX_INSTALLMENTS]: {
            isActive: Boolean(1),
            interestRate: 0.007945,
            interestRatePromo: 0.007945,
            interestRateMonthly: 0.241666,
            installmentsMin: 3,
            installmentsMax: 6,
            installmentsDefault: 6,
        },
        [PRODUCT_LOAN_SIX_INSTALLMENTS_PAYDAY]: {
            isActive: Boolean(1),
            interestRate: 0.008,
            interestRatePromo: 0.008,
            interestRateMonthly: 0.24,
            installmentsMin: 3,
            installmentsMax: 6,
            installmentsDefault: 6,
        },
        googleMapsApiKey: 'AIzaSyDOzUJ1pgsDEU9MiJYzEVagQsvrgyE3_NU', // https://console.cloud.google.com/apis/dashboard
        getAddressApiKey: 'I8Ij1ky9pEyAQ5p2hqF2bQ47427',
    }

    export const LOCALE = {
        currencyPrefix: '£',
        currencySuffix: '',
        decimal: '.',
        separator: ',',
    }

    export const ROUTE = {
        validatePromoCode: 'https://monixa.co.uk/promocode',
        validateEmail: 'https://monixa.co.uk/registration/validate/email',
        validatePhone: 'https://monixa.co.uk/registration/validate/phone',
        validatePerson: 'https://monixa.co.uk/registration/validate/person',
        validatePinCode: 'https://monixa.co.uk/registration/validate/pin',
        validatePinCodeSend: 'https://monixa.co.uk/registration/validate/pin-send',
        registrationPhoneChange: 'https://monixa.co.uk/registration/phone-change',
        clientPhonePinValidate: 'https://monixa.co.uk/client/phone/pincode',
        clientPhoneChange: 'https://monixa.co.uk/client/phone/change',
        clientEmailChange: 'https://monixa.co.uk/client/email/change',
        registrationEmailChange: 'https://monixa.co.uk/registration/email/change',
        validateCardDetails: 'https://monixa.co.uk/acquired/validate/card',
        processingCheckRegistration: 'https://monixa.co.uk/registration/processing/check',
        processingCheckClient: 'https://monixa.co.uk/client/processing/check',
        resendEmail: 'https://monixa.co.uk/registration/resend/email',
        emailChecked: 'https://monixa.co.uk/registration/check/email',

        leadReferralRegistrationStatus: 'https://monixa.co.uk/registration/lead-referral/status',
        leadReferralClientStatus: 'https://monixa.co.uk/client/loan/lead-referral/status',
    }

    export const SECURITY = {
        clientLogin: 'https://monixa.co.uk/client/login',
        clientLogout: 'https://monixa.co.uk/client/logout',
        clientRelogin: 'https://monixa.co.uk/client/relogin'
    }